document.addEventListener('DOMContentLoaded', function() {
    const modal = document.getElementById('mini-cart-popup');
    const closeButton = document.querySelector('.modal__popup__close__btn');
 
    function checkConditionAndShowModal() {
        modal.classList.add('visible'); // 모달을 보이게 설정
    }

    const checkoutButton = document.getElementById('checkout-btn');
    const checkoutFakeButton = document.getElementById('checkout-fake-btn');
    
    if (checkoutFakeButton) {
        checkoutFakeButton.addEventListener('click', function(event) {
            event.preventDefault(); 
            const cartItems = document.querySelectorAll('.line-item');
            let allTrue = true;
            let allFalse = true;

            cartItems.forEach(item => {
                const value = item.getAttribute('data-preorder');
                if (value === 'true') {
                    allFalse = false;
                } else {
                    allTrue = false;
                }
            });

            if (!allTrue && !allFalse) {
                checkConditionAndShowModal(); // 조건에 따라 모달을 보이게 하기
            } else {
                if (checkoutButton) {
                    checkoutButton.click(); // 체크아웃 버튼 클릭
                } else {
                    console.error('체크아웃 버튼을 찾을 수 없음');
                }
            }
        });
    }
    // 모달 닫기 버튼 클릭 이벤트
    if (closeButton) {
        closeButton.addEventListener('click', function(event) {
            event.preventDefault(); 
            modal.classList.remove('visible'); 
        });
    }
});
